import React, { createContext, useContext, useState } from "react";
import '../styles/Toast.css';

const ToastContext = createContext();

export function ToastProvider({ children }) {
    const [ toasts, setToasts ] = useState([]);

    function addToast( message, isError = false , timeout = 5000 ) {
        const id = Date.now();
        setToasts( (prev) => [...prev, { id, message, isError }] );

        setTimeout( () => {
            removeToast(id);
        }, timeout );
    }

    function removeToast(id) {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }

    return (
        <ToastContext.Provider value={addToast}>
            <div className="toast-container">
                <div className="toast-wrap">
                    {toasts.slice().reverse().map((toast, index) => {
                        const isCurrent = index === 0;
                        const isOlderCard = index > 0;

                        let startingZindex = toasts.length;
                        let nextZIndex = toasts.length - index;

                        let startingScale = 1;
                        let nextScale = startingScale - 0.02;
                        let minScale = 0.7;
                        if ( nextScale < minScale ) {
                            nextScale = minScale;
                        }

                        let starting = 3;
                        let nextPos = starting * index;
                        let maxPos = 30;
                        if ( nextPos > maxPos ) {
                            nextPos = maxPos;
                        }

                        return(
                            <div
                                key={toast.id}
                                className={`toast ${toast.isError ? "error" : ""} ${
                                    isOlderCard ? "behind" : ""
                                }`}
                                style={{
                                    top: isOlderCard ? `${nextPos}px` : 0,
                                    background: isOlderCard ? '#838383' : '#000000',
                                    zIndex: isCurrent ? startingZindex : nextZIndex,
                                    transform: isCurrent ? `scale(1.0)` : `scale(0.98)`,
                                    color: isOlderCard ? '#838383' : "#ffffff"
                                
                                }}
                            >
                                {toast.message}
                                <button
                                    className="close-btn"
                                    onClick={() => removeToast(toast.id)}
                                >
                                    ✕
                                </button>
                            </div>
                        )
                    })}
                </div>
            </div>
            {children}
        </ToastContext.Provider>
    );
}

export function useToast() {
    return useContext(ToastContext);
}
